import { render, staticRenderFns } from "./SatellitalEvolutionChart.vue?vue&type=template&id=15388b92&scoped=true"
import script from "./SatellitalEvolutionChart.vue?vue&type=script&lang=ts"
export * from "./SatellitalEvolutionChart.vue?vue&type=script&lang=ts"
import style0 from "./SatellitalEvolutionChart.vue?vue&type=style&index=0&id=15388b92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15388b92",
  null
  
)

export default component.exports